export enum TipoPagoType {
    TOTAL = "total",
    PARCIAL = "parcial",
    DESCUENTO = "descuento",    
    INCIDENCIA ="incidencia",    
}
  